export default {
  namespaced: true,
  state: {
    vod: 0,
    status: false,
    category: null
  },
  mutations: {
    setVod(state, data) {
      state.vod = data
    },
    setStatus(state, data) {
      state.status = data
    },
    setCategory(state, data) {
      state.category = data
    }
  },
  getters: {
    category: state => {
      return state.category
    },
    categories: (state, getters) => {
      const categories = getters.vods.map(vod => vod.category)
      return categories.filter(_$.unique)
    },
    vod: (state, getters) => {
      return getters.vods[state.vod]
    },
    vods: (state, getters, rootState) => {
      if (!Array.isArray(rootState.data.vods)) return []
      return rootState.data.vods.map(vod => {
        vod.slug = vod.category?.slugify()
        return vod
      })
    },
    status: state => {
      return state.status
    }
  }
}
